

(function($) {
  
  $('html').removeClass('no-js').addClass('js');
  $(function() {
    pix_ready();
  })
})(jQuery);

function pix_exit_page(){
  //Reset body class
  jQuery('body').removeClass('is-loginform-shown');
  jQuery('body').removeClass('is-overlay-visible');
  jQuery('body').removeClass('is-popup-lockedpost-shown');
}

function pix_ready(){
  jQuery('body').attr('class', jQuery('#body-class').attr('class'))
  jQuery('body').trigger('pix_ready')
  //console.log('main rdy')

  initLoader();
  initGeneral();

  initCardEvent();
  initCardHorizontal();
  initCardPost();
  initFooterMenu();
  initFooterNewsletter();
  initGoToTop();
  initHeaderMainMenu();
  initHeaderMenuOpener();
  initHeaderQuickmenuMobile();
  initHomeCardsScroll();
  initMemberFormPage();
  initOpenUserMenu();
  initOverlayFullpage();
  initPagePresentation();
  initPopinLoginform();
  initPopinSearchform();
  initPopup();
  initPrecontentSlider();
  initProfileFormPage()
  initSearchformArchive();
  initTopStickyMenu();
  initWpTheContent();
}

function initGeneral(){
  var $ = jQuery;
  $('html').removeClass('no-js').addClass('js');
  
  $(document).ready(function() {
    $('a').each(function(){
      href = $(this).attr('href');
      if(href && !$(this).hasClass('nojs')){
        if(href.indexOf('#') == 0 || $(this).hasClass('has-no-transition') || $(this).hasClass('fancybox') || $(this).parent().hasClass('menu-item-has-children') || $(this).hasClass('js-locked-post') || $(this).attr('target') == '_blank'){
          //rien faire si est un anchor dans la page
        }else if(href.indexOf('wp-content/uploads/') >= 0){
          $(this).attr('target','_blank');
        }else if(href.indexOf(window.location.hostname) >= 0){
          //internal
          $(this).addClass('is-internal animsition-link')
        }else if(href.indexOf('mailto') < 0 && href.indexOf('dev.rqd') < 0){
          //external
          $(this).attr('target','_blank')
        }
      }
    })
    /*if (navigator.appName == 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) || (typeof $.browser !== "undefined" && $.browser.msie == 1)){
      $('.animsition').css('opacity',1)
    }else{
      $('.animsition').animsition({
        inDuration: 500,
        outDuration: 400,
      })
    }
    $('.animsition').on('animsition.inEnd', function(){
      console.log('eh');
      jQuery('[data-waypoint]').waypoint({});
    })*/


    // Select all links with hashes
    $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
        // On-page links
        event.preventDefault();
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
            && 
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top-50
                }, 300, function() {
                    // Callback after animation
                    // Must change focus!
                    /*var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                    } else {
                        $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    };*/
                });
            }
        }
    });

  });
}

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function getQueryVariable(variable){
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}